/**
 * Rate estimates (ADR 0039, ADR 0041): the range under the worker's rate question, beside the household's budget and
 * in answer to a market question in the chat, with what it rests on (jobs on GigSync, the city's rate card), the suggestion
 * each owner confirms or changes, and the note on an offer far outside the range.
 */
export const estimate = {
    "estimate.range_job": "{trade} in {city}{scope}: usually {low}–{high} for the job.",
    "estimate.range_month": "{trade} in {city}{scope}: usually {low}–{high} a month.",
    "estimate.range_visit": "{trade} in {city}{scope}: usually {low}–{high} a visit.",
    "estimate.range_day": "{trade} in {city}{scope}: usually {low}–{high} a day.",
    "estimate.range_hour": "{trade} in {city}{scope}: usually {low}–{high} an hour.",
    "estimate.range_sqft": "{trade} in {city}{scope}: usually {low}–{high} a square foot painted.",
    "estimate.scope": " ({scope})",
    "estimate.rooms.bhk1": "1 BHK",
    "estimate.rooms.bhk2": "2 BHK",
    "estimate.rooms.bhk3": "3 BHK",
    "estimate.rooms.bhk4_plus": "4 BHK or more",
    "estimate.labour.yes": "labour only",
    "estimate.labour.no": "with paint",
    "estimate.frequency.daily": "every day",
    "estimate.frequency.alternate_days": "every other day",
    "estimate.frequency.weekly": "once a week",
    "estimate.people.1_2": "1–2 people",
    "estimate.people.3_4": "3–4 people",
    "estimate.people.5_plus": "5 or more people",
    "estimate.meals.1": "1 meal a day",
    "estimate.meals.2": "2 meals a day",
    "estimate.meals.3": "3 meals a day",
    "estimate.hours.up_to_6": "up to 6 hours a day",
    "estimate.hours.7_to_9": "7–9 hours a day",
    "estimate.hours.10_plus": "10 or more hours a day",
    "estimate.problem.fan": "a fan",
    "estimate.problem.switch": "a switch",
    "estimate.problem.light": "a light",
    "estimate.problem.wiring": "wiring",
    "estimate.problem.leak": "a leak",
    "estimate.problem.tap": "a tap",
    "estimate.problem.blockage": "a blockage",
    "estimate.problem.toilet": "a toilet",
    "estimate.problem.door": "a door",
    "estimate.problem.repair": "a repair",
    "estimate.problem.assembly": "assembling furniture",
    "estimate.problem.service": "a service",
    "estimate.problem.gas_refill": "a gas refill",
    "estimate.problem.install": "installing one",
    "estimate.jobs.one": "From {count} job on GigSync in {place}.",
    "estimate.jobs.other": "From {count} jobs on GigSync in {place}.",
    "estimate.reason_jobs.one": "The usual rate for this job is {low}–{high}, from {count} job on GigSync.",
    "estimate.reason_jobs.other": "The usual rate for this job is {low}–{high}, from {count} jobs on GigSync.",
    "estimate.market_none": "I can't say yet what {trade} usually charges in {place}: too few jobs on GigSync and too few prices on the web.",
    "estimate.amount_below": "{amount} is below that range.",
    "estimate.amount_within": "{amount} is within that range.",
    "estimate.amount_above": "{amount} is above that range.",
    "estimate.answer": "{text}",
    "estimate.legal_min": "Nothing here is below the legal minimum of {min}.",
    "estimate.suggest_rate": "I suggest opening at {price}. Tap to use it, or say your own.",
    "estimate.suggest_min": "I suggest {price} as the least you take. Tap to use it, or say your own.",
    "estimate.suggest_budget": "I suggest a budget of {price}. Tap to use it, or say your own.",
    "estimate.use": "Use {price}",
    "estimate.below": "Well below the usual rate for this job ({low}–{high}).",
    "estimate.above": "Well above the usual rate for this job ({low}–{high}).",
};
//# sourceMappingURL=estimate.js.map